<template>
  
</template>

<script>
export default {
    mounted(){
        location.href = `https://${location.host}`;
    }
}
</script>

<style>

</style>